import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          精选综艺
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑精选优质综艺，总有一档适合你
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card) => (
            <a
              key={card.id}
              href="#carousel"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                    {card.tag}
                  </span>
                  <span className="text-xs text-primary-500 font-medium">{card.update}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {card.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}